export default __webpack_public_path__ + "static/media/jackpot1.6aa6bd62.png";